import DictionaryMappingService from '@/creditflowresearch/domain/DictionaryMapping';
import {
  transformIndustries,
  transformSectors,
} from '@/creditflowresearch/application/Dictionaries/serverSide/legacyMappers';
import type { IDictionariesState } from '@/creditflowresearch/application/Dictionaries/helpers';
import type { TPageDictionaries } from '@/creditflowresearch/application/Dictionaries/DictionaryRegistry';

interface ISectorsIndustriesSource {
  dictionaries?: IDictionariesState,
  pageDictionaries?: TPageDictionaries,
}

type TSectorsIndustries = Pick<IDictionariesState, 'sectorsList' | 'industriesList' | 'industriesListAll'>;

const getServerSideSectorsIndustries = ({
  dictionaries,
  pageDictionaries,
}: ISectorsIndustriesSource): TSectorsIndustries => {
  if (dictionaries) {
    return {
      sectorsList: dictionaries.sectorsList,
      industriesList: dictionaries.industriesList,
      industriesListAll: dictionaries.industriesListAll,
    };
  }

  const industriesListAll = transformIndustries(pageDictionaries?.industries ?? []);

  return {
    sectorsList: DictionaryMappingService.getMappedSectors(transformSectors(pageDictionaries?.sectors ?? [])),
    industriesList: DictionaryMappingService.getMappedIndustries(industriesListAll),
    industriesListAll,
  };
};

export default getServerSideSectorsIndustries;
